var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('headerComponent',{attrs:{"callback":_vm.headerCallbackHandler}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }